export default "__VITE_ASSET__d68517c6__"